module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/sms-icon-active-0ca94a7fb1edee3270667ef390438f54.svg";